import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/sentry/box/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/sentry/box/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/sentry/box/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/sentry/box/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/park/sentry/box/update/v2', params, options);

export const getBondPassages = (params, options) =>
  request.post('/api/park/sentrybox/passage/list/v2', qs.stringify(params), options);

export const sentryBoxBindPassage = (params, options) =>
  request.post('/api/park/sentrybox/passage/bind/v2', params, options);

export const getSentryBoxList = (params, options) =>
  request.get('/api/park/sentry/box/list/v2', Object.assign({}, options, {
    params
  }));
